export default function setupSmoothScroll () {
    window.addEventListener('DOMContentLoaded', smoothScrollToHome);
}



/**
 * Adds smooth scroll behavior to the home link if the user is on the homepage.
 * Anchor links (#section) get their smooth scrolling from `scroll-behavior: smooth` on <html>.
 */
function smoothScrollToHome () {
    const homeLink = document.querySelector('.main-nav__home-link');
    if ( !homeLink ) return;

    if ( window.location.pathname === '/' ) {
        homeLink.addEventListener('click', evt => {
            evt.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }
}
